import getFormattedDate, { dateFormats } from '../../../../shared/utils/dateFormatHelper'

export default function getTitleFromGroup(group) {
  let title = group?.metadata?.title ?? ''
  if (title && group?.coverages?.length) {
    title += ': '
  }

  if (group?.coverages) {
    group.coverages.forEach((coverage, i) => {
      if (coverage.place?.name) {
        if (i > 0) {
          title += ' | '
        }
        title += `${coverage.place.name}.`

        if (coverage.recordTypes) {
          coverage.recordTypes.forEach((recordType, j) => {
            if (j > 0) {
              title += ','
            }
            if (recordType.name) {
              title += ` ${recordType.name}`
            }

            if (recordType.date?.length) {
              title += ` ${recordType.date
                ?.map((date) => getFormattedDate(date.fromTimestamp, date.toTimestamp, dateFormats.formatted))
                .join(', ')}`
            }
          })
        }
      }
    })
  }
  return title
}
